module.exports = "https://www.gc-pro.gnp.com.mx/d7223beb13c0dcc0501107cbe04912ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/registro/3.png
// module id = 1052
// module chunks = 0 1